// src/components/ProductsSection_SalesOfMonth.tsx
"use client";

import React from 'react';
import ProductsSliderClient from './ProductsSliderClient';
import Link from 'next/link';
import Image from 'next/image';
import AddToCartButtonInList from '@/components/add_to_cart_popup/AddToCartButtonInList';
import { MiniCartProvider } from '@/app/context/MiniCartContext';

type Brand = {
    id: string;
    name: string;
    slug: string;
};

type Product = {
    id: string;
    name: string;
    slug: string;
    price?: string;
    stockQuantity?: number;
    convertedPrice?: string;
    customSalePrice?: number | null;
    hasCustomDiscount?: boolean;
    image?: {
        sourceUrl?: string;
        altText?: string;
    };
    brands?: {
        nodes: Brand[];
    };
};

export default function FeaturedProductsSection({ products }: { products: Product[] }) {
    const formatNumber = (num: number) => num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    const formatPrice = (price: string | undefined): string => {
        if (!price) {
            return "Цена не указана";
        }
        return price
            .replace(/&nbsp;/g, " ")
            .replace(/\u00A0/g, " ")
            .replace("UZS", "сӯм");
    };

    return (
        <section className="home_product_section" id='slider_sales'>
            <div className="products_section_heading">
                <div className="general_heading_block">
                    <div className="prods_sec_nav">
                        <h2 className="active__">Акция месяца 🔥</h2>
                    </div>
                    <Link className="section_read_more" href="/sales-of-month">Все предложения</Link>
                </div>
                <div className="orange_heading_divider"></div>
            </div>

            <div className="swiper products_slider">
                <div className="swiper-wrapper">
                    {products.map((product) => {

                        // $ оставил для типизации
                        const numericPrice = product.convertedPrice
                            ? parseFloat(product.convertedPrice.replace(/[^\d.]/g, '')) / 1
                            : 0;

                        const priceNumber = product.price ? parseFloat(product.price.replace(/[^\d.]/g, '')) : 0;
                        const formattedPrice = priceNumber.toLocaleString('ru-RU') + ' сӯм';

                        const regularPriceInSum = product.price ? parseFloat(product.price.replace(/[^\d]/g, '')) : 0;
                        const oldPriceInSum = product.customSalePrice || 0;
                        const discountPercent =
                            product.hasCustomDiscount &&
                                oldPriceInSum > 0 &&
                                regularPriceInSum > 0 &&
                                oldPriceInSum > regularPriceInSum
                                ? Math.round(((oldPriceInSum - regularPriceInSum) / oldPriceInSum) * 100)
                                : 0;

                        return (
                            <div className="swiper-slide product_item relative" key={product.id}>
                                {discountPercent > 0 && (
                                    <div
                                        className="absolute top-0 left-0 bg-[#ff7900] text-white font-bold px-3 py-1 text-sm z-10"
                                        style={{ borderRadius: '10px 0 10px 0' }}
                                    >
                                        -{discountPercent}%
                                    </div>
                                )}
                                <Link href={`/product/${product.slug}`} aria-label={product.name}>
                                    <Image
                                        className="product_item__image"
                                        src={product.image?.sourceUrl ?? '/images/products/default.jpg'}
                                        alt={product.image?.altText ?? product.name}
                                        width={200}
                                        height={200}
                                    />
                                </Link>
                                <div className="product_meta_box">
                                    {product.brands && product.brands.nodes.length > 0 ? (
                                        <Link
                                            href={`/product-brands/${product.brands.nodes[0].slug}`}
                                            className="product_item__brand"
                                        >
                                            {product.brands.nodes[0].name}
                                        </Link>
                                    ) : (
                                        <span className="product_item__brand">Без бренда</span>
                                    )}

                                    <div className="line_highlight"></div>

                                    <Link href={`/product/${product.slug}`} className="product_item__name">
                                        {product.name}
                                    </Link>

                                    <span className="product_item__price">
                                        {product.hasCustomDiscount && product.customSalePrice ? (
                                            <div className="flex flex-col flex-wrap md:flex-row md:gap-2 items-center justify-center">
                                                <span className="relative inline-block w-fit text-red-500 md:text-xs text-base after:content-[''] after:absolute after:left-0 after:top-1/2 after:w-full after:h-[1px] after:bg-red-500 after:-translate-y-[300%]">
                                                    {formatNumber(product.customSalePrice)}
                                                </span>
                                                <span className="">
                                                    {formattedPrice}
                                                    <span className="text-xs ml-1">🔥</span>
                                                </span>
                                            </div>
                                        ) : (
                                            formattedPrice
                                        )}
                                    </span>
                                </div>
                                <MiniCartProvider>
                                    <AddToCartButtonInList
                                        productId={product.id}
                                        productName={product.name}
                                        productImage={product.image?.sourceUrl ?? '/images/products/default.jpg'}
                                        productPrice={numericPrice}
                                        maxQuantity={product.stockQuantity || 0}
                                    />
                                </MiniCartProvider>
                            </div>
                        );
                    })}
                </div>
                {/* <div className="swiper-button-next"></div>
                <div className="swiper-button-prev"></div> */}
            </div>
            <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div>
            <ProductsSliderClient />
        </section>
    );
}
